import { lazy } from 'react';

export const NotFoundPage = lazy(() =>
  import('src/pages/NotFoundPage/ui/NotFoundPage').then((module) => ({
    default: module.NotFoundPage,
  }))
);
